"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
require("../../styles/myAccount/addressInformation.scss");
var _react = _interopRequireDefault(require("react"));
var _formatAddress = require("../formatAddress");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _withState = _interopRequireDefault(require("recompose/withState"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _ButtonToolbar = _interopRequireDefault(require("angieslist-react-components/lib/ButtonToolbar"));
var _ListGroup = _interopRequireDefault(require("angieslist-react-components/lib/ListGroup"));
var _ListGroupItem = _interopRequireDefault(require("angieslist-react-components/lib/ListGroupItem"));
var _Panel = _interopRequireDefault(require("angieslist-react-components/lib/Panel"));
var _ButtonGroup = _interopRequireDefault(require("angieslist-react-components/lib/ButtonGroup"));
var _addAddressModal = _interopRequireDefault(require("./modals/addAddressModal"));
var AddressInformation = function AddressInformation(_ref) {
  var editButtonStyle = _ref.editButtonStyle,
    _ref$fetchUser = _ref.fetchUser,
    isUserLoading = _ref$fetchUser.isLoading,
    user = _ref$fetchUser.response,
    userError = _ref$fetchUser.error,
    _ref$deleteUserAddres = _ref.deleteUserAddress,
    isDeleteAddressLoading = _ref$deleteUserAddres.isLoading,
    deleteAddressRequest = _ref$deleteUserAddres.request,
    deleteAddressError = _ref$deleteUserAddres.error,
    _ref$setPrimaryAddres = _ref.setPrimaryAddress,
    isSetPrimaryLoading = _ref$setPrimaryAddres.isLoading,
    setPrimaryAddressRequest = _ref$setPrimaryAddres.request,
    setPrimaryError = _ref$setPrimaryAddres.error,
    deleteUserAddressApi = _ref.deleteUserAddressApi,
    setPrimaryAddressApi = _ref.setPrimaryAddressApi,
    showModal = _ref.showModal,
    setShowModal = _ref.setShowModal;
  var errorMessage = (0, _getErrorMessage["default"])(userError || deleteAddressError || setPrimaryError);
  var addresses = (0, _get2["default"])(user, 'addresses', []);
  var nonPrimaryAddresses = (0, _filter2["default"])(addresses, {
    'isPrimary': false
  });
  var deleteRequestUserAddressId = (0, _get2["default"])(deleteAddressRequest, 'userAddressId');
  var primaryRequestUserAddressId = (0, _get2["default"])(setPrimaryAddressRequest, 'userAddressId');
  var userId = (0, _get2["default"])(user, 'userId');
  var primaryAddress = (0, _find2["default"])(addresses, {
    'isPrimary': true
  });
  var handleShow = function handleShow() {
    return setShowModal(true);
  };
  var handleClose = function handleClose() {
    return setShowModal(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, "Address Information")), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, !isUserLoading && !(0, _isEmpty2["default"])(user) ? [/*#__PURE__*/_react["default"].createElement("address", {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Primary Address:"), /*#__PURE__*/_react["default"].createElement("br", null), primaryAddress ? (0, _formatAddress.formatAddress)(primaryAddress) : 'No primary address on file'), /*#__PURE__*/_react["default"].createElement("p", {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Other Addresses:")), /*#__PURE__*/_react["default"].createElement(_addAddressModal["default"], {
    editButtonStyle: editButtonStyle,
    userId: userId,
    showModal: showModal,
    handleClose: handleClose,
    key: "2"
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
    style: {
      marginBottom: 11
    },
    key: "3"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "address-information--add-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    style: {
      fontWeight: 'bold'
    },
    onClick: handleShow
  }, "Add New Location"))), /*#__PURE__*/_react["default"].createElement(_ListGroup["default"], {
    key: "4"
  }, (0, _map2["default"])(nonPrimaryAddresses, function (address) {
    var userAddressId = address.userAddressId,
      addressId = address.addressId;
    var deleteAddressIdMatch = deleteRequestUserAddressId === userAddressId;
    var primaryAddressIdMatch = primaryRequestUserAddressId === userAddressId;
    var isDeleteLoading = isDeleteAddressLoading && deleteAddressIdMatch;
    var isPrimaryLoading = isSetPrimaryLoading && primaryAddressIdMatch;
    var showErrorOnRow = !(0, _isEmpty2["default"])(deleteAddressError) && deleteAddressIdMatch || !(0, _isEmpty2["default"])(setPrimaryError) && primaryAddressIdMatch ? {
      bsStyle: 'danger'
    } : {};
    var deleteButtonId = "address-information--delete-".concat(userAddressId, "-button");
    var makePrimaryButtonId = "address-information--primary-".concat(userAddressId, "-button");
    return /*#__PURE__*/_react["default"].createElement(_ListGroupItem["default"], (0, _extends2["default"])({
      key: userAddressId,
      style: {
        padding: '20px 15px'
      }
    }, showErrorOnRow), (0, _formatAddress.formatAddress)(address), /*#__PURE__*/_react["default"].createElement(_ButtonToolbar["default"], {
      className: "btn-toolbar-right"
    }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: deleteButtonId,
      bsStyle: editButtonStyle,
      bsSize: "xsmall",
      ghost: true,
      onClick: function onClick() {
        return deleteUserAddressApi(userAddressId, addressId);
      },
      disabled: isDeleteLoading || isPrimaryLoading,
      loading: isDeleteLoading
    }, "Delete")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: makePrimaryButtonId,
      bsStyle: editButtonStyle,
      bsSize: "xsmall",
      ghost: true,
      onClick: function onClick() {
        return setPrimaryAddressApi(userAddressId, addressId);
      },
      disabled: isPrimaryLoading || isDeleteLoading,
      loading: isPrimaryLoading
    }, "Make Primary"))));
  }))] : null));
};
AddressInformation.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  fetchUser: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    response: _propTypes["default"].shape({
      addresses: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        userAddressId: _propTypes["default"].number.isRequired,
        addressId: _propTypes["default"].number.isRequired,
        firstLine: _propTypes["default"].string.isRequired,
        secondLine: _propTypes["default"].string,
        city: _propTypes["default"].string.isRequired,
        region: _propTypes["default"].string.isRequired,
        postalCode: _propTypes["default"].string.isRequired,
        isPrimary: _propTypes["default"].bool.isRequired
      }))
    }),
    error: _propTypes["default"].object
  }).isRequired,
  deleteUserAddress: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    request: _propTypes["default"].shape({
      userAddressId: _propTypes["default"].number.isRequired
    }),
    error: _propTypes["default"].object
  }).isRequired,
  setPrimaryAddress: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    request: _propTypes["default"].shape({
      userAddressId: _propTypes["default"].number.isRequired
    }),
    error: _propTypes["default"].object
  }).isRequired,
  deleteUserAddressApi: _propTypes["default"].func.isRequired,
  setPrimaryAddressApi: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired,
  setShowModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _withState["default"])('showModal', 'setShowModal', false), _pure["default"])(AddressInformation);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/addressInformation.js
// module id = 4254
// module chunks = 9